import { defineMessages } from 'react-intl'

export default defineMessages({
  title: 'Become a part of our family'
})
